import { useQuery } from '@tanstack/react-query';
import { http } from '@/lib/http';
import type { Lang } from '@/app/[lang]/providers/LocaleProvider';

type LocalizedText = string | Partial<Record<Lang, string>> | null;

export interface SiteSettingsData {
  id: number;
  background_image: string | null;
  background_image_alt: string | null;
  background_image_webp: string | null;
  background_image_avif: string | null;
  popup_image: string | null;
  popup_image_alt: string | null;
  popup_image_webp: string | null;
  popup_image_avif: string | null;
  popup_title: LocalizedText;
  popup_title_en?: string | null;
  popup_title_id?: string | null;
  popup_desc: LocalizedText;
  popup_desc_en?: string | null;
  popup_desc_id?: string | null;
  popup_is_active: boolean | null;
  contact_us_success_dialog_title: string | null;
  contact_us_success_dialog_content: string | null;
  facebook_url: string | null;
  instagram_url: string | null;
  twitter_url: string | null;
  linkedin_url: string | null;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
}

export interface SiteSettingsResponse {
  data: SiteSettingsData;
}

export function useSiteSettings(lang?: Lang) {
  return useQuery<SiteSettingsResponse>({
    queryKey: ['site-settings', lang],
    queryFn: async () => {
      const res = await http.get('/api/site-settings', {
        params: lang ? { lang, locale: lang } : undefined,
      });
      return res.data;
    },
  });
}
